$(function () {

    var controlContactSelector = $(".control-contact-selector");

    if (controlContactSelector.length) {
        $('#person-select').change(function () {
            var personUrl = $(this).val();

            window.location = personUrl;
        });
    }
});